module.exports = __webpack_public_path__ + "img/SKMJ_submit3.81e649aa.jpg";